// extracted by mini-css-extract-plugin
module.exports = {"base":"Spinner_base__OD2iP","spin":"Spinner_spin__2uJTs","rotate":"Spinner_rotate__38Q1x","center":"Spinner_center__1QOR0","rotateCentered":"Spinner_rotateCentered__-9VaK"};